import React from "react";


const Communities = () => {
    const openWebsite = () => {
        window.open("https://app.psicopatici.com", "_blank");
    };
    return (
        <>
            <header style={{marginTop: "100px"}} className="">
                <div className="container">
                    <div className="section_title text-center">
                        <h1 className="fw-bolder text-wrap text-break fs-2 fs-sm-1 fs-md-1">
                            CONNETTI, CREA, CRESCI: DIVENTA PARTNER COMMUNITY
                        </h1>
                        <h4 className="text-center fs-5 fs-md-4">
                            Collabora con Psicopatici Italia e guadagna valorizzando il tuo network.
                        </h4>
                    </div>
                </div>
            </header>

            {/* Pulsante che scrolla al form */}
            <div className="d-flex align-items-center justify-content-center mb-4 mt-4">
                <button className="btn-invia" style={{width: "200px", fontSize: "18px"}} onClick={openWebsite}>
                    Candidati ora
                </button>

            </div>

            <div className="row justify-content-center mb-4 px-2">
                <div className="col-12 col-sm-10 col-md-8 col-lg-6">
                    <p className="text-center" style={{fontSize: "16px"}}>
                        Costruisci e fai crescere comunità, online o offline, trasformando la
                        forza delle connessioni in esperienze condivise. Porta la tua community all’interno
                        dell’ecosistema di Psicopatici Italia per farla evolvere e raggiungere nuovi traguardi. </p>
                </div>
            </div>

            <section className="how-it-works">
                <div className="container">
                    <h2>Come iniziare a guadagnare come Partner Community?</h2>
                    <div className="cards-container">
                        {[
                            {
                                title: "Registrati in pochi minuti",
                                desc: "Compila il modulo online, che troverai nella specifica pagina Partner, con i dati richiesti. La tua candidatura verrà valutata entro 24 ore e, se approvata, sarai subito operativo."
                            },
                            {
                                title: "Accedi alla tua dashboard personale",
                                desc: "Se approvata, riceverai via email le tue credenziali per accedere all’area riservata, dove potrai generare il tuo link partner, creare contenuti e monitorare in tempo reale vendite, commissioni e bonus crediti."
                            },
                            {
                                title: "Inizia a guadagnare",
                                desc: "Non ti resta che condividere il tuo link partner con i tuoi follower o con chi vorrai e far crescere la tua rete per iniziare a guadagnare commissioni remunerative su ogni acquisto. I pagamenti saranno trasparenti e puntuali, erogati a cadenza trimestrale."
                            }
                        ].map((item, i) => (
                            <div key={i} className="card1" style={{display: "flex", flexDirection: "column"}}>
                                <p><strong>{item.title}</strong></p>
                                <p style={{color: "gray", fontSize: "14px"}}>{item.desc}</p>
                            </div>
                        ))}
                    </div>

                    <div className="mt-4">
                        <h2>Tipologie di commissioni: </h2>
                        <div className="cards-container">
                            {[
                                {
                                    range: "Commissione di Appartenenza",
                                    value: "Ti verrà riconosciuta per ogni acquisto effettuato da un cliente che avrai portato tu attraverso il tuo link partner.\n" +
                                        "Ogni cliente da te acquisito genera valore e tu ne ricevi sempre una parte."
                                },
                                {
                                    range: "Commissioni di Vendita",
                                    value: "Verrà calcolata su ogni acquisto generato attraverso i tuoi contenuti personali, attività promozionali o qualsiasi tua azione volta a sponsorizzare il brand."
                                },
                            ].map((item, i) => (
                                <div key={i} className="card1" style={{display: "flex", flexDirection: "column"}}>
                                    <p><strong>{item.range}</strong></p>
                                    <p style={{color: "gray", fontSize: "14px"}}>{item.value}</p>
                                </div>
                            ))}
                        </div>
                    </div>


                    <div className="mt-4">
                        <h2>Dettaglio Commissioni:</h2>
                        <div className="cards-container">
                            {[
                                {
                                    range: "Da 0–50 acquisti", value: "5% di Commissione di Appartenenza\n" +
                                        "10% di Commissione di Vendita"
                                },
                                {
                                    range: "Da 51–300 acquisti", value: "6% di Commissione di Appartenenza\n" +
                                        "12% di Commissione di Vendita"
                                },
                                {
                                    range: "Da 301–1000 acquisti", value: "7% di Commissione di Appartenenza\n" +
                                        "14% di Commissione di Vendita"
                                },
                                {
                                    range: "Oltre 1000 acquisti", value: "8% di Commissione di Appartenenza\n" +
                                        "16% di Commissione di Vendita"
                                }
                            ].map((item, i) => (
                                <div key={i} className="card1" style={{display: "flex", flexDirection: "column"}}>
                                    <p><strong>{item.range}</strong></p>
                                    <p style={{
                                        color: "gray",
                                        fontSize: "14px",
                                        whiteSpace: "pre-line"
                                    }}>{item.value}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            <section className="how-it-works">
                <div className="container">
                    <h2>Perché diventare Partner Community?</h2>
                    <div className="cards-container">
                        {[
                            "Candidatura gratuita e veloce.",
                            "Nessun investimento iniziale richiesto ed entra nel nostro programma Partner senza costi di ingresso.",
                            "Aumentare la positività della tua community offrendo loro la possibilità di acquistare capi sartoriali e personalizzabili in base alle loro esigenze e misure.",
                            "Accesso al gestionale con possibilità di monitorare in tempo reale l’andamento delle conversioni generate."
                        ].map((text, i) => (
                            <div key={i} className="card1">
                                <p>{text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>


            <section className="how-it-works">
                <div className="container">
                    <h2>I benefici riservati ai nostri partner</h2>
                    <div className="cards-container">
                        {[
                            "Guadagni crescenti in base alla quantità di vendite: più acquisti generi, più aumenta la tua commissione.",
                            "Connessioni reali: Unisci le tue community, forum e associazioni a una rete più ampia,rafforzando legami.",
                            "Visibilità e riconoscimento: la tua community sarà pubblicata sui nostri canali social ufficiali Psicopatici Italia, con menzioni, condivisioni e coinvolgimento diretto alle iniziative.",
                        ].map((text, i) => (
                            <div key={i} className="card1">
                                <p>{text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* REQUISITI */}
            <section className="how-it-works">
                <div className="container">
                    <h2>Chi può diventare Partner Community?</h2>
                    <div className="cards-container">
                        <div className="card1">
                            <p>Community digitali</p>
                        </div>
                        <div className="card1">
                            <p>-Forum o network attivi</p>
                        </div>
                        <div className="card1">
                            <p>Associazioni di moda</p>
                        </div>
                    </div>
                </div>
            </section>
            <div className="d-flex align-items-center justify-content-center mb-4 mt-4">
                <button className="btn-invia" style={{width: "200px", fontSize: "18px"}} onClick={openWebsite}>
                    Candidati ora
                </button>

            </div>

            <footer>
                <div className="container">
                    <p>&copy; 2025 Psicopatici Italia. Tutti i diritti riservati.</p>
                </div>
            </footer>
        </>
    );
}

export default Communities;